export default {
  agreed: 'De acuerdo',
  searchStatement: 'Términos de búsqueda del servicio',
  noData: 'No hay más datos',
  starts: 'Estrella',
  searching: 'Buscando',
  searchService: 'Términos de búsqueda del servicio',
  filter: {
    performanceQuality: 'Calidad de rendimiento',
    comprehensiveExperienceScore: 'Puntuación de experiencia comprensiva',
    fourStartDown: 'Menos de cuatro estrellas',
    certifiedFactory: 'Fábrica certificada',
    dayYield: 'Tasa de rendimiento en 24 horas',
    doubleDayYield: 'Tasa de rendimiento en 48 horas',
    performanceGuarantee: 'Garantía de rendimiento',
    dayShipments: 'Envío el mismo día',
    strictSelect: 'Selección estricta',
    disStrictSelect: 'Selección estricta de distribución',
    dayShip: 'Entrega en 24 horas',
    doubleDayShip: 'Entrega en 48 horas',
    sevenDayNoReason: 'Siete días sin motivo',
    oneIssuing: 'Soporte para enviar una pieza por cuenta ajena',
    onePostIssuing:
      'Soporte para envío gratuito (El envío de una pieza por cuenta ajena es gratuito)',
    sevenDayNew: '7 días para productos nuevos',
    thirtyDayNew: '30 días para productos nuevos',
    wordStrictSelect: 'Selección estricta global',
    isSelect: 'Paletas de selección transfronteriza',
    priceSort: 'Clasificación por precio',
    compositeSort: 'Clasificación comprensiva',
    up: 'Guardar',
    reset: 'Restablecer',
    moreFilters: 'Más criterios de filtrado',
    bestMatch: 'Mejor coincidencia',
    saleHighToLow: 'Ventas: De mayor a menor',
    saleLowToHigh: 'Ventas: De menor a mayor',
    priceHighToLow: 'Precio: De mayor a menor',
    priceLowToHigh: 'Precio: De menor a mayor',
    fastToSlow: 'Tiempo de envío: De rápido a lento',
    slowToFast: 'Tiempo de envío: De lento a rápido'
  }
};